import { PartnerType } from "@/app/utils/partners.enum"
import { httpClient } from "../http/httpClient"

export type ExternalAlert = {
  active: boolean
  title: string
  subtitle: string
  cta?: string
  block: boolean
  image?: string
}

export type ExternalProductsResponse = {
  [key in PartnerType]?: {
    active: boolean
    alert?: ExternalAlert
    color?: string
    title?: string
    subtitle?: string
    image?: string
  }
}
export async function getProducts() {
  const response = await httpClient.get<ExternalProductsResponse>('/config/ms-config', {
    params: {
      action: 'products'
    }
  })
  return response.data
}